import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { IBomModel, IShoppingCart } from '../../../prisma-xs/models/bom.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-whole-saler-confirmation-modal',
    templateUrl: './whole-saler-confirmation-modal.component.html',
    styleUrls: ['./whole-saler-confirmation-modal.component.scss'],
    standalone: false
})
export class WholeSalerConfirmationModalComponent {
  @ViewChild('wholesalerIntegration') wholesalerIntegrationEl: ConfirmationModalComponent;
  @Input() bomModels: IBomModel[];
  @Input() numberOfApartments = 1;
  @Input() bomModelsProjectComponents: IBomModel[];
  @Input() bomModelsAccessories: IBomModel[];
  customDevicesIncluded: boolean;
  preWiringDevicesIncluded: boolean;
  numberOfPositions: number;
  openedFromElbridge2 = false;

  @Output() goToShoppingCart = new EventEmitter();
  @Output() goToElbridge2ShoppingCart = new EventEmitter();

  constructor(private readonly cd: ChangeDetectorRef) {}

  open(shoppingCart: IShoppingCart) {
    this.preWiringDevicesIncluded = shoppingCart?.preWiringDevicesIncluded;
    this.customDevicesIncluded = shoppingCart?.wholesalerUnableToTransferDevicesIncluded;
    this.numberOfPositions = shoppingCart?.numberOfPositions;

    this.cd.markForCheck();
    this.wholesalerIntegrationEl.openModal();
  }

  openFromElbridge2(shoppingCart: IShoppingCart): void {
    this.openedFromElbridge2 = true;
    this.open(shoppingCart);
  }

  onGoToShoppingCart() {
    if (this.openedFromElbridge2) {
      this.goToElbridge2ShoppingCart.emit();
      return;
    }
    this.goToShoppingCart.emit();
  }
}
